// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7ba89e1c","977":"3a877463"}[chunkId] + ".chunk.js";
};